import React from "react";
import { WeekDay } from "@/types/hotelService";

const DAYS_IN_WEEK = 7;

const AvailabilityCell = ({ availableDays }: { availableDays: WeekDay[] }) => {
  return (
    <span>
      {availableDays.length === DAYS_IN_WEEK
        ? "Whole week"
        : availableDays.join(",")}
    </span>
  );
};

export default AvailabilityCell;
